function SearchFileData() {
  return {
    url: ""
  }
}

export { SearchFileData };
